var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStorepickup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#storepickup_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.762 13.094H7.609v7.45h8.153z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9 8.798h-1.961V4.791h-.003l-1.34-1.33v1.33-1.33H7.722v.002L6.385 4.791h-.003v4.007H4.413v12.275H18.9zm-3.61 6H7.915v-1.465h7.375zm-4.11.925v4.512H7.914v-4.512h3.264Zm.846 4.512v-4.512h3.264v4.512zM7.733 4.805h7.854v3.993H7.733z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "storepickup_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 3h15.3v18H4z"
})))));
export default SvgStorepickup;